"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionViewModel = questionViewModel;
function questionViewModel(question) {
    return question;
}
